const locale = {
    placeholder: 'Vaqtni tanlang',
    rangePlaceholder: ['Boshlanish vaqti', 'Yakunlash vaqti'],
};
export default locale;
